import React, { ReactNode } from 'react';
import { Sidebar } from './Sidebar';

interface BackofficeLayoutProps {
  children: ReactNode;
}

export const BackofficeLayout: React.FC<BackofficeLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-slate-nav">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="ms-64 flex-1 flex flex-col min-h-screen bg-slate-nav text-gray-200">
        <main className="flex-1 p-8 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
};
